import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { setResultsCurrentQuestions, updateTabStates } from '../../../store/actions';
import { componentsToColor } from 'pdf-lib';

export default function LeftMenuResults() {

    const dispatch = useDispatch();

    const themeMode = useSelector(state => state.themeMode);
    // const currentSurveyResult = useSelector(state => state.currentSurveyResult);
    const topMenuTabs = useSelector((state) => state.topMenuTabs);
    
    // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
    const currentSurveyResult = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurveyResult;
    const resultsCurrentQuestions = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.resultsCurrentQuestions;

    const [sections, setSections] = useState([]);

    useEffect(() => {
        let _newSections = [];
        currentSurveyResult?.forEach((res) => {
            let _newSection = {
                name: res["section"],
                open: false,
                pages: []
            }
            let _newPages = [];
            res["data"].forEach((data) => {

                if (data.type !== "text" && data.type != "comment" && data.type !=  "tagbox" && data.type !=  "checkbox" && data.type !=  "ranking" && data.type != "boolean") {
                    if (!_newPages.map(x => x.name).includes(data["page"])) {
                        const is_open =   data["question_id"] === resultsCurrentQuestions?.question_id ? true : false;
                        _newPages.push({
                            name: data["page"],
                            open: is_open,
                            questions: [{name:data["question"],  id: data["question_id"]}]
                        });
                        if (!_newSection.open) {
                            _newSection.open = is_open;
                        }
                    } else {
                        _newPages.forEach((page) => {
                            if (page.name === data["page"]) {
                                page.questions.push({name:data["question"],  id: data["question_id"]});
                                if (data["question_id"] === resultsCurrentQuestions.question_id) {
                                    _newSection.open = true;
                                    page.open = true;
                                }
                            }
                        });
                    }
                }
            });
            _newSection.pages = _newPages;
            _newSections.push(_newSection);
        });
        setSections(_newSections);
    }, [currentSurveyResult]);

    useEffect(() => {
        if (resultsCurrentQuestions?.name) {
            sections.forEach((section) => {
                section.pages.forEach((page) => {
                    page.questions.forEach((question) => {
                        if (question.id === resultsCurrentQuestions.question_id) {
                            section.open = true;
                            page.open = true;
                        }
                    });
                });
            });
            setSelectedItem({
                question_id: resultsCurrentQuestions.question_id,
                name: resultsCurrentQuestions.name,
                type: resultsCurrentQuestions.type,
            });
        }
    }, [resultsCurrentQuestions]);

    const [selectedResultsMenuItem, setSelectedResultsMenuItem] = useState();
    const [selectedResultsMenuKey, setSelectedResultsMenuKey] = useState();
    const [selectedItem, setSelectedItem] = useState({
        question_id:"",
        type: "",
        name: "",
    });

    const changeSelectedItem = (id,name, type) => {
        setSelectedItem({
            question_id:id,
            name: name,
            type: type,
        });
        // dispatch(setResultsCurrentQuestions({
        //     name: name,
        //     type: type,
        // }));
        dispatch(updateTabStates(topMenuTabs.activeTab, 'resultsCurrentQuestions', {
            question_id:id,
            name: name,
            type: type
        }));
    };

    return (
        <div>
            <div className="flex cursor-default items-center justify-between rounded-lg pt-[0.75rem] pr-[0.75rem] pb-[1.5rem] pl-[1.25rem] text-[1.25rem] font-bold space-x-2">
                <span
                    className={` whitespace-nowrap break-words text-ellipsis  min-w-0 w-full cursor-default ${themeMode === "dark" ? "text-white" : "text-[#0F121A]"
                        }`}
                >
                    Results
                </span>
            </div>

            <div className="max-h-[calc(100vh-150px)] overflow-y-auto">
                <ul className="px-3 space-y-0 flex flex-col" id="resultsLeftMenuNavigate">
                    {sections.map((sectionValue, sectionKey) => (
                        <li
                            key={sectionKey}
                            className=" flex flex-col min-h-[2rem] my-0 py-0 group"
                            onClick={(e) => {
                                e.stopPropagation();
                                changeSelectedItem(sectionValue.pages[0].questions[0].question_id,sectionValue.pages[0].questions[0].name, "question");
                                // changeSelectedItem(sectionValue.name, "section");
                            }}
                        >
                            <div
                                className={`flex cursor-pointer items-center justify-between min-h-[2rem] rounded-lg px-2 py-1 hover:bg-[#A5BDFF1A] ${themeMode === "dark" ? "text-white" : "text-gray-500"
                                    } 
                                    ${(selectedItem.name === sectionValue.name && selectedItem.type === "section") ? "bg-[#A5BDFF1A]" : "hover:bg-[#A5BDFF1A]"}
                                    `}
                            >
                                <div className="flex items-center justify-between w-full">
                                    <div className="flex items-center">
                                        <span
                                            className={`text-sm font-normal whitespace-nowrap break-words text-ellipsis overflow-hidden min-w-0 ${themeMode === "dark"
                                                ? `${(selectedItem.name === sectionValue.name && selectedItem.type === "section")
                                                    ? "text-[#4D7FF5]"
                                                    : "focus:ring-2 focus:ring-blue-500"
                                                }`
                                                : `text-[#0F121A] ${(selectedItem.name === sectionValue.name && selectedItem.type === "section")
                                                    ? "text-[#3566E2]"
                                                    : "focus:ring-2 focus:ring-blue-500"
                                                }`
                                                }`}
                                        >
                                            {sectionValue.name}
                                        </span>
                                    </div>

                                    {sectionValue.pages && (
                                        <div
                                            className="flex items-center"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                sectionValue.open = !sectionValue.open;
                                                setSections([...sections]);
                                            }}
                                        >
                                            <span className="mr-2">
                                                <svg
                                                    className="size-4"
                                                    fill="currentColor"
                                                    viewBox="0 0 16 16"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    transform={!sectionValue.open ? "rotate(270)" : ""}
                                                >
                                                    <path d="M7.8,10.8L11.7,7H4L7.8,10.8z"></path>
                                                </svg>
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>

                       
                            {sectionValue.pages && sectionValue.open && (
                                <ul className="pl-2 space-y-0 flex flex-col">
                                    {sectionValue.pages.map((page, index) => (
                                    <li
                                        key={index}
                                        className=" flex flex-col min-h-[2rem] my-0 py-0 group"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        // page.questions listesinin ilk elemanı artık obje: {name, id}
                                        if (page.questions?.[0]) {
                                            changeSelectedItem(page.questions[0].id, page.questions[0].name, "question");
                                        }
                                        }}
                                    >
                                        <div
                                                className={`flex cursor-pointer items-center justify-between min-h-[2rem] rounded-lg px-2 py-1 hover:bg-[#A5BDFF1A] ${themeMode === "dark" ? "text-white" : "text-gray-500"
                                                    } ${(selectedItem.name === page.name && selectedItem.type === "page")
                                                        ? "bg-[#A5BDFF1A]"
                                                        : "hover:bg-[#A5BDFF1A]"
                                                    }`}
                                            >
                                                <span
                                                    className={`text-sm font-normal whitespace-nowrap break-words text-ellipsis overflow-hidden min-w-0 ${themeMode === "dark"
                                                        ? `${(selectedItem.name === page.name && selectedItem.type === "page")
                                                            ? "text-[#4D7FF5]"
                                                            : "focus:ring-2 focus:ring-blue-500"
                                                        }`
                                                        : `text-[#0F121A] ${(selectedItem.name === page.name && selectedItem.type === "page")
                                                            ? "text-[#3566E2]"
                                                            : "focus:ring-2 focus:ring-blue-500"
                                                        }`
                                                        }`}
                                                >
                                                    {page.name}
                                                </span>
                                        <div onClick={(e) => { e.stopPropagation(); page.open = !page.open; setSections([...sections]); }}>
                                            {/* toggle icon */}
                                               <span className="mr-2">
                                                        <svg
                                                            className="size-4"
                                                            fill="currentColor"
                                                            viewBox="0 0 16 16"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            transform={!page.open ? "rotate(270)" : ""}
                                                        >
                                                            <path d="M7.8,10.8L11.7,7H4L7.8,10.8z"></path>
                                                        </svg>
                                                    </span>
                                        </div>
                                        </div>

                                        {page.questions && page.open && (
                                        <ul className="pl-2 pt-2 space-y-0 flex flex-col gap-y-2">
                                            {page.questions.map((questionObj, qIndex) => (
                                            <li
                                                key={questionObj.id|| qIndex} // id varsa kullan
                                                className=" flex items-center min-h-[2rem] my-0 py-0 group"
                                                onClick={(e) => {
                                                e.stopPropagation();
                                                changeSelectedItem(questionObj.id, questionObj.name, "question");
                                                }}
                                            >
                                                <div
                                                className={`text-sm font-normal break-words whitespace-normal text-ellipsis rounded-lg cursor-pointer
                                                overflow-hidden min-w-0 px-2 py-1 hover:bg-[#A5BDFF1A] 
                                                ${themeMode === "dark"
                                                    ? `${(selectedItem.question_id === questionObj.id&& selectedItem.type === "question")
                                                        ? "text-[#4D7FF5] bg-[#A5BDFF1A]"
                                                        : "text-white focus:ring-2 focus:ring-blue-500"
                                                        }`
                                                    : `text-[#0F121A] ${(selectedItem.question_id === questionObj.id&& selectedItem.type === "question")
                                                        ? "text-[#3566E2]"
                                                        : "focus:ring-2 focus:ring-blue-500"
                                                        }`
                                                    }`}
                                                >
                                                {questionObj.name}
                                                </div>
                                            </li>
                                            ))}
                                        </ul>
                                        )}
                                    </li>
                                    ))}
                                </ul>
                            )}

                        </li>
                    ))}
                </ul>
            </div>
            
            <div
                className={`h-px mt-4 ${themeMode === "dark" ? "bg-[#ffffff17]" : "bg-[#0000001a]"
                    }`}
            ></div>
        </div>
    )
}
